<h6 class="box-header">
  <ng-content></ng-content>
</h6>